import React from "react";
import {
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
	Flex,
} from "@chakra-ui/react";
import { CloseButton } from "components/RFQ/CloseButton";
import { useFormikContext } from "formik";
import PreviewRfxDraft from "pages/RFQ/RFQ/CreateRFQ/PreviewRFQ/components/PreviewRfxDraft";
import { convertDraftRfxDataToRfx } from "newui/features/Rfx/Creation/data-processor";
import { useCurrentCompany } from "hooks/auth";

const PreviewRFQ = ({
	isOpen,
	isTemplate,
	rfqData,
	onClose,
	documentCategories,
	previewTab,
	...props
}) => {
	const { values: formValues } = useFormikContext();
	const currentCompany = useCurrentCompany();

	const rfxData = convertDraftRfxDataToRfx(
		formValues,
		rfqData,
		props?.rfqTypes,
		currentCompany,
		isTemplate
	);

	return (
		<div>
			<Drawer
				placement={"right"}
				isOpen={isOpen}
				onClose={onClose}
				size="xl"
				{...props}
				className="bg-white p-11"
			>
				<DrawerOverlay onClick={onClose} />
				<DrawerContent maxWidth={"1280px"}>
					<DrawerHeader>
						<Flex
							justifyContent="space-between"
							align={"center"}
						>
							<div>
								<p className="text-lg font-semibold text-primary-900">
									This is a Preview of the RFx as the Supplier will see it
								</p>
							</div>
							<CloseButton onClose={onClose} />
						</Flex>
					</DrawerHeader>
					<DrawerBody>
						<PreviewRfxDraft
							rfxTypes={props?.rfqTypes}
							isDraftPreview={true}
							rfxData={rfxData}
							documentCategories={documentCategories}
							isTemplate={isTemplate}
							previewTab={previewTab}
						/>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</div>
	);
};

export default PreviewRFQ;
